export const locKeys = {
  showMore: "merchCampaign.showMoreButton",
  offers: "merchCampaign.offers",
};
